module.exports = __webpack_public_path__ + "img/this_feature_is_unavailable.286cc876.svg";